/**
 * TLF Delivery Planner — pincode check + delivery date + time slot.
 * Native replacement for the Easify date/slot fields.
 * Saves on the order as line-item properties:
 *   Delivery Date (DD/MM/YYYY), Delivery Time Slot, Delivery Pincode
 * Blocks Add to Bag (incl. sticky bar) until everything required is filled.
 * Also adds a 'Buy now' button (main + sticky bar): validates, adds to bag, goes to checkout.
 * Also powers the 'Live Guitarist' add-on card.
 */
(function () {
  'use strict';
  if (window.__tlfDP) { window.__tlfDP.scan(); return; }

  /* ---------- CONFIG (zones + slots) ---------- */
  var ZONES = [
    { city: 'Delhi',         fee: 299, ranges: [[110001, 110096]] },
    { city: 'Noida',         fee: 499, ranges: [[201301, 201309], [201313, 201313]] },
    { city: 'Gurugram',      fee: 699, ranges: [[122001, 122018]] },
    { city: 'Greater Noida', fee: 699, ranges: [[201306, 201306], [201310, 201310], [201312, 201312]] },
    { city: 'Faridabad',     fee: 899, ranges: [[121001, 121010]] },
    { city: 'Ghaziabad',     fee: 899, ranges: [[201001, 201017]] }
  ];
  var SLOTS = [
    { label: '11:00 AM - 2:00 PM',  start: 11 },
    { label: '2:00 PM - 5:00 PM',   start: 14 },
    { label: '5:00 PM - 8:00 PM',   start: 17 },
    { label: '8:00 PM - 11:00 PM',  start: 20 },
    { label: '11:00 PM - 12:00 AM', start: 23 }
  ];
  var PIN_KEY = 'tlf_delivery_pincode';
  var SEL_KEY = 'tlf_dp_sel';
  var PIN_TTL = 1000 * 60 * 60 * 24 * 30;
  var P_DATE = 'properties[Delivery Date]';
  var P_SLOT = 'properties[Delivery Time Slot]';
  var P_PIN  = 'properties[Delivery Pincode]';
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  /* ---------- shared state (survives section re-renders) ---------- */
  var state = { pin: '', zone: null, date: '', slot: '' };
  try {
    var savedPin = JSON.parse(localStorage.getItem(PIN_KEY) || 'null');
    if (savedPin && Date.now() - savedPin.ts < PIN_TTL && /^\d{6}$/.test(savedPin.pin)) {
      state.pin = savedPin.pin;
      state.zone = lookup(savedPin.pin);
    }
  } catch (e) {}
  try {
    var savedSel = JSON.parse(sessionStorage.getItem(SEL_KEY) || 'null');
    if (savedSel) { state.date = savedSel.date || ''; state.slot = savedSel.slot || ''; }
  } catch (e) {}

  function persistSel() {
    try { sessionStorage.setItem(SEL_KEY, JSON.stringify({ date: state.date, slot: state.slot })); } catch (e) {}
  }
  function persistPin() {
    try {
      if (state.pin) localStorage.setItem(PIN_KEY, JSON.stringify({ pin: state.pin, result: state.zone ? { serviceable: true, city: state.zone.city, fee: state.zone.fee } : { serviceable: false }, ts: Date.now() }));
      else localStorage.removeItem(PIN_KEY);
    } catch (e) {}
  }

  /* ---------- helpers ---------- */
  function lookup(pin) {
    var n = parseInt(pin, 10);
    for (var i = 0; i < ZONES.length; i++) {
      for (var j = 0; j < ZONES[i].ranges.length; j++) {
        var r = ZONES[i].ranges[j];
        if (n >= r[0] && n <= r[1]) return ZONES[i];
      }
    }
    return null;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function istNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour % 24, min: +parts.minute };
  }
  function utcDate(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function fmt(dt) { return pad(dt.getUTCDate()) + '/' + pad(dt.getUTCMonth() + 1) + '/' + dt.getUTCFullYear(); }
  function parseFmt(s) {
    var m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(s || '');
    return m ? utcDate(+m[3], +m[2], +m[1]) : null;
  }
  function cfg(root) {
    return {
      cutoff: parseFloat(root.dataset.cutoff) || 16,
      lead: parseFloat(root.dataset.lead) || 3,
      days: parseInt(root.dataset.days, 10) || 60,
      chips: parseInt(root.dataset.chips, 10) || 10,
      blocked: (root.dataset.blocked || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean)
    };
  }
  function todayStr() { var n = istNow(); return fmt(utcDate(n.y, n.m, n.d)); }
  function slotsFor(dateStr, c) {
    if (c.blocked.indexOf(dateStr) !== -1) return [];
    var n = istNow();
    var today = fmt(utcDate(n.y, n.m, n.d));
    var target = parseFmt(dateStr);
    if (!target) return [];
    var base = utcDate(n.y, n.m, n.d);
    var diff = Math.round((target - base) / 864e5);
    if (diff < 0 || diff > c.days) return [];
    if (dateStr !== today) return SLOTS.slice();
    var nowH = n.h + n.min / 60;
    if (nowH >= c.cutoff) return [];
    return SLOTS.filter(function (s) { return s.start >= nowH + c.lead; });
  }
  function slotValid(dateStr, slot, c) {
    return slotsFor(dateStr, c).some(function (s) { return s.label === slot; });
  }

  /* ---------- per-planner wiring ---------- */
  var planners = [];

  function scopeOf(root) {
    return root.closest('safe-sticky, .product-info, quick-buy-modal, quick-buy-drawer, .quick-buy, section') || document;
  }
  function formOf(root) {
    var scope = scopeOf(root);
    var forms = scope.querySelectorAll('form[action*="/cart/add"]');
    var fallback = null;
    for (var i = 0; i < forms.length; i++) {
      var fid = forms[i].getAttribute('id') || '';
      if (/installment/.test(fid)) continue;
      if (forms[i].querySelector('buy-buttons, [type="submit"]')) return forms[i];
      if (!fallback) fallback = forms[i];
    }
    return fallback;
  }
  function easifyHandlesDelivery(root) {
    var scope = scopeOf(root);
    var labels = scope.querySelectorAll('.po-label-label, .po-field-root label');
    for (var i = 0; i < labels.length; i++) {
      if (/delivery\s*(date|time)/i.test(labels[i].textContent)) return true;
    }
    return false;
  }
  function setHidden(form, name, value) {
    var input = form.querySelector('input[type="hidden"][name="' + name + '"][data-tlf-dp]');
    if (value == null || value === '') { if (input) input.remove(); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-tlf-dp', '');
      form.appendChild(input);
    }
    input.value = value;
  }

  function init(root) {
    if (root.__tlfInit) return;
    root.__tlfInit = true;
    var c = cfg(root);
    var el = {
      pin: root.querySelector('[data-dp-pin]'),
      check: root.querySelector('[data-dp-check]'),
      pinMsg: root.querySelector('[data-dp-pinmsg]'),
      when: root.querySelector('[data-dp-when]'),
      dates: root.querySelector('[data-dp-dates]'),
      more: root.querySelector('[data-dp-more]'),
      moreBtn: root.querySelector('[data-dp-morebtn]'),
      dateSel: root.querySelector('[data-dp-datesel]'),
      slots: root.querySelector('[data-dp-slots]'),
      err: root.querySelector('[data-dp-err]')
    };
    var p = { root: root, c: c, el: el, easify: false };
    planners.push(p);

    /* pincode */
    function runCheck() {
      var v = (el.pin.value || '').replace(/\D/g, '').slice(0, 6);
      el.pin.value = v;
      if (!/^[1-9]\d{5}$/.test(v)) {
        state.pin = ''; state.zone = null;
        showPin(p, 'Please enter a valid 6-digit pincode.', 'bad');
        renderAll();
        return;
      }
      state.pin = v;
      state.zone = lookup(v);
      persistPin();
      clearError(p);
      renderAll();
    }
    el.check.addEventListener('click', runCheck);
    el.pin.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); runCheck(); } });
    el.pin.addEventListener('input', function () {
      el.pin.value = el.pin.value.replace(/\D/g, '').slice(0, 6);
      if (el.pin.value.length === 6) runCheck();
    });

    /* dates */
    el.dates.addEventListener('click', function (e) {
      var b = e.target.closest('[data-date]');
      if (!b || b.disabled) return;
      selectDate(b.getAttribute('data-date'));
    });
    if (el.more) {
      var n = istNow();
      var base = utcDate(n.y, n.m, n.d);
      var max = new Date(base.getTime() + c.days * 864e5);
      el.more.min = base.toISOString().slice(0, 10);
      el.more.max = max.toISOString().slice(0, 10);
      el.more.addEventListener('change', function () {
        if (!el.more.value) return;
        var parts = el.more.value.split('-');
        var ds = parts[2] + '/' + parts[1] + '/' + parts[0];
        if (!slotsFor(ds, c).length) {
          showError(p, 'Sorry, that date is not available. Please pick another.');
          return;
        }
        selectDate(ds);
      });
      if (el.moreBtn) {
        el.moreBtn.addEventListener('click', function () {
          try { if (el.more.showPicker) { el.more.showPicker(); return; } } catch (e) {}
          el.more.focus(); el.more.click();
        });
      }
    }
    function selectDate(ds) {
      state.date = ds;
      if (state.slot && !slotValid(ds, state.slot, c)) state.slot = '';
      persistSel();
      clearError(p);
      renderAll();
    }

    /* slots */
    el.slots.addEventListener('click', function (e) {
      var b = e.target.closest('[data-slot]');
      if (!b || b.disabled) return;
      state.slot = b.getAttribute('data-slot');
      persistSel();
      clearError(p);
      renderAll();
    });

    render(p);
  }

  function showPin(p, msg, kind) {
    p.el.pinMsg.className = 'tlf-dp__pinmsg' + (kind ? ' is-' + kind : '');
    p.el.pinMsg.innerHTML = msg;
  }
  function showError(p, msg) {
    p.root.classList.add('is-invalid');
    p.el.err.hidden = false;
    p.el.err.textContent = msg;
  }
  function clearError(p) {
    p.root.classList.remove('is-invalid');
    p.el.err.hidden = true;
    p.el.err.textContent = '';
  }

  function render(p) {
    var c = p.c, el = p.el, root = p.root;
    p.easify = false; /* native date & slot always shown — remove Easify's own Delivery Date / Time Slot fields */
    root.classList.toggle('tlf-dp--easify', p.easify);

    /* pincode */
    if (document.activeElement !== el.pin) el.pin.value = state.pin;
    if (state.pin && state.zone) {
      showPin(p, '<span aria-hidden="true">&#10003;</span> Delivering to <strong>' + state.zone.city + '</strong> &middot; ' + state.pin, 'ok');
    } else if (state.pin) {
      showPin(p, 'Sorry, we don&rsquo;t deliver to ' + state.pin + ' yet. <a href="https://wa.me/' + (root.dataset.whatsapp || '') + '" target="_blank" rel="noopener">Ask us on WhatsApp</a>', 'bad');
    } else if (!/is-bad/.test(el.pinMsg.className)) {
      showPin(p, '', '');
    }

    var pinOK = !!(state.pin && state.zone);
    el.when.hidden = !pinOK || p.easify;

    /* drop stale selections */
    if (state.date && !slotsFor(state.date, c).length) { state.date = ''; state.slot = ''; persistSel(); }
    if (state.slot && !slotValid(state.date, state.slot, c)) { state.slot = ''; persistSel(); }

    /* date chips */
    var n = istNow();
    var base = utcDate(n.y, n.m, n.d);
    var html = '';
    var shown = {};
    for (var i = 0; i < c.chips; i++) {
      var dt = new Date(base.getTime() + i * 864e5);
      var ds = fmt(dt);
      shown[ds] = true;
      var avail = slotsFor(ds, c).length > 0;
      var top = i === 0 ? 'Today' : (i === 1 ? 'Tmrw' : DAYS[dt.getUTCDay()]);
      html += '<button type="button" class="tlf-dp__date' + (state.date === ds ? ' is-selected' : '') + '" data-date="' + ds + '"' + (avail ? '' : ' disabled') + ' aria-pressed="' + (state.date === ds) + '">' +
        '<small>' + top + '</small><strong>' + dt.getUTCDate() + '</strong><small>' + MONTHS[dt.getUTCMonth()] + '</small></button>';
    }
    if (state.date && !shown[state.date]) {
      var sd = parseFmt(state.date);
      html += '<button type="button" class="tlf-dp__date is-selected" data-date="' + state.date + '" aria-pressed="true"><small>' + DAYS[sd.getUTCDay()] + '</small><strong>' + sd.getUTCDate() + '</strong><small>' + MONTHS[sd.getUTCMonth()] + '</small></button>';
    }
    el.dates.innerHTML = html;
    if (el.dateSel) {
      var sel = parseFmt(state.date);
      el.dateSel.textContent = sel ? DAYS[sel.getUTCDay()] + ', ' + sel.getUTCDate() + ' ' + MONTHS[sel.getUTCMonth()] : '';
    }

    /* slots */
    var avail2 = state.date ? slotsFor(state.date, c) : [];
    var sh = '';
    if (!state.date) {
      sh = '<p class="tlf-dp__hint">Choose a date to see available slots</p>';
    } else {
      SLOTS.forEach(function (s) {
        var ok = avail2.some(function (a) { return a.label === s.label; });
        sh += '<button type="button" class="tlf-dp__slot' + (state.slot === s.label ? ' is-selected' : '') + '" data-slot="' + s.label + '"' + (ok ? '' : ' disabled') + ' aria-pressed="' + (state.slot === s.label) + '">' + s.label.replace(' - ', ' – ') + '</button>';
      });
    }
    el.slots.innerHTML = sh;

    /* write hidden properties into the product form */
    var form = formOf(root);
    if (form) {
      form.__tlfPlanner = p;
      setHidden(form, P_PIN, pinOK ? state.pin + ' (' + state.zone.city + ')' : '');
      if (p.easify) {
        setHidden(form, P_DATE, '');
        setHidden(form, P_SLOT, '');
      } else {
        setHidden(form, P_DATE, pinOK && state.date ? state.date : '');
        setHidden(form, P_SLOT, pinOK && state.date && state.slot ? state.slot : '');
      }
    }
  }

  function renderAll() { planners = planners.filter(function (p) { return document.contains(p.root); }); planners.forEach(render); }

  function problem(p) {
    if (!state.pin || !state.zone) return state.pin ? 'We don’t deliver to this pincode yet.' : 'Please enter your delivery pincode.';
    if (p.easify) return '';
    if (!state.date) return 'Please choose a delivery date.';
    if (!state.slot || !slotValid(state.date, state.slot, p.c)) return 'Please choose a delivery time slot.';
    return '';
  }

  /* ---------- block Add to Bag until complete ---------- */
  function guard(e, form) {
    if (!form || !form.__tlfPlanner) return;
    var p = form.__tlfPlanner;
    if (!document.contains(p.root)) return;
    render(p);
    var msg = problem(p);
    if (!msg) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showError(p, msg);
    p.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (!state.pin || !state.zone) { setTimeout(function () { p.el.pin.focus({ preventScroll: true }); }, 400); }
  }
  document.addEventListener('submit', function (e) { guard(e, e.target); }, true);
  /* apps (e.g. Easify) may intercept the button click before the form submits — guard the click too */
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
    if (!btn || !btn.form) return;
    guard(e, btn.form);
  }, true);

  /* ---------- long descriptions: show a preview + 'Read more' ---------- */
  function clampDescriptions() {
    document.querySelectorAll('.product-content-below-gallery__description, [data-block-type="description"] .prose').forEach(function (d) {
      if (d.__tlfClamp || !d.offsetHeight) return;
      d.__tlfClamp = true;
      if (d.scrollHeight < 300) return;
      d.classList.add('tlf-clamp');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tlf-more';
      var closed = '<span>Read more</span><i aria-hidden="true">+</i>';
      var opened = '<span>Show less</span><i aria-hidden="true">&minus;</i>';
      b.innerHTML = closed;
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var open = d.classList.toggle('is-open');
        b.innerHTML = open ? opened : closed;
        b.setAttribute('aria-expanded', String(open));
        if (!open) d.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      d.insertAdjacentElement('afterend', b);
    });
  }

  /* ---------- Buy now: add to bag, then straight to checkout (only when everything required is valid) ---------- */
  var BN_KEY = 'tlf_buynow';
  var bnUntil = 0;
  var bnClicking = false;
  function bnArm() { bnUntil = Date.now() + 10000; try { sessionStorage.setItem(BN_KEY, String(bnUntil)); } catch (e) {} }
  function bnGo() { bnUntil = 0; try { sessionStorage.removeItem(BN_KEY); } catch (e) {} window.location.assign('/checkout'); }
  function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); }
  var _fetch = window.fetch;
  if (window.fetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var pr = _fetch.apply(this, arguments);
      if (isAdd(url) && Date.now() < bnUntil) {
        pr.then(function (r) { if (r && r.ok && Date.now() < bnUntil) bnGo(); }).catch(function () {});
      }
      return pr;
    };
  }
  var _xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (isAdd(u)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300 && Date.now() < bnUntil) bnGo(); });
    return _xhrOpen.apply(this, arguments);
  };
  /* non-ajax fallback: the add landed us on /cart right after Buy now */
  try {
    var bnT = +sessionStorage.getItem(BN_KEY);
    if (bnT && Date.now() < bnT && /^\/cart\/?$/.test(location.pathname)) { sessionStorage.removeItem(BN_KEY); location.replace('/checkout'); }
  } catch (e) {}

  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-tlf-buynow]');
    if (!t) {
      var sb = e.target.closest && e.target.closest('button[type="submit"]');
      if (sb && !bnClicking) bnUntil = 0; /* a normal Add to cart must never redirect */
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    var sub = t.parentNode.querySelector('button[type="submit"]');
    if (!sub || !sub.form) return;
    var p = sub.form.__tlfPlanner;
    if (p) {
      render(p);
      var msg = problem(p);
      if (msg) {
        showError(p, msg);
        p.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (!state.pin || !state.zone) { setTimeout(function () { p.el.pin.focus({ preventScroll: true }); }, 400); }
        return;
      }
    }
    bnArm();
    bnClicking = true;
    try { sub.click(); } finally { bnClicking = false; }
  }, true);

  var bnStyle = document.createElement('style');
  bnStyle.textContent = 'buy-buttons[data-tlf-bn]{display:flex!important;flex-direction:row;gap:.6rem;align-items:stretch}' +
    'buy-buttons[data-tlf-bn] .button{flex:1 1 0;min-width:0;width:auto;padding-inline:.5rem;letter-spacing:.1em;white-space:nowrap}' +
    'product-sticky-bar buy-buttons[data-tlf-bn]{flex:1 1 auto;max-width:26rem}';
  document.head.appendChild(bnStyle);

  function addBuyNow() {
    document.querySelectorAll('buy-buttons').forEach(function (bb) {
      var sub = bb.querySelector('button[type="submit"]');
      if (!sub || sub.disabled || bb.querySelector('[data-tlf-buynow]')) return;
      if (!(sub.form && sub.form.__tlfPlanner)) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'button tlf-buynow';
      b.setAttribute('data-tlf-buynow', '');
      b.textContent = 'Buy now';
      sub.classList.add('button--outline');
      bb.setAttribute('data-tlf-bn', '');
      sub.insertAdjacentElement('afterend', b);
    });
  }

  /* ---------- Live Guitarist add-on card (adds the guitarist product to the cart with the order) ---------- */
  var GT_KEY = 'tlf_gt';
  var gt = { on: false, spend: 0, loaded: false };
  try { gt.on = sessionStorage.getItem(GT_KEY) === '1'; } catch (e) {}
  var gtBypass = false;
  function gtVariant() { var c = document.querySelector('[data-tlf-gt]'); return c ? parseInt(c.getAttribute('data-variant'), 10) : 0; }
  function inr(n) { return Math.round(n).toLocaleString('en-IN'); }
  function gtRender() {
    document.querySelectorAll('[data-tlf-gt]').forEach(function (c) {
      var t = c.querySelector('[data-gt-toggle]');
      if (t) t.checked = gt.on;
      c.classList.toggle('is-on', gt.on);
      var price = parseFloat(c.getAttribute('data-price')) || 0;
      var thr = parseFloat(c.getAttribute('data-threshold')) || 0;
      var main = parseFloat(c.getAttribute('data-product-price')) || 0;
      var free = thr > 0 && (main + gt.spend) >= thr;
      var el = c.querySelector('[data-gt-price]');
      if (el) el.innerHTML = free
        ? '<b>Complimentary</b> with this order'
        : '+ &#8377;' + inr(price) + ' <span>&middot; free on orders above &#8377;' + inr(thr) + '</span>';
    });
  }
  function gtLoadSpend() {
    if (gt.loaded || !document.querySelector('[data-tlf-gt]') || !_fetch) return;
    gt.loaded = true;
    _fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var v = gtVariant();
      gt.spend = cart.items.filter(function (i) { return i.variant_id !== v; }).reduce(function (a, i) { return a + i.final_line_price; }, 0) / 100;
      gtRender();
    }).catch(function () {});
  }
  document.addEventListener('change', function (e) {
    var t = e.target.closest && e.target.closest('[data-gt-toggle]');
    if (!t) return;
    gt.on = !!t.checked;
    try { sessionStorage.setItem(GT_KEY, gt.on ? '1' : '0'); } catch (e2) {}
    gtRender();
  });
  function gtEnsure(form) {
    var vid = gtVariant();
    if (!vid) return Promise.resolve(true);
    return _fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.items.some(function (i) { return i.variant_id === vid; })) return true;
      var props = {};
      [['Delivery Pincode', P_PIN], ['Delivery Date', P_DATE], ['Delivery Time Slot', P_SLOT]].forEach(function (k) {
        var inp = form.querySelector('input[type="hidden"][name="' + k[1] + '"][data-tlf-dp]');
        if (inp && inp.value) props[k[0]] = inp.value;
      });
      return _fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] })
      }).then(function (r) { return r.ok; });
    }).catch(function () { return false; });
  }
  /* runs after the delivery guard, so the guitarist is only added once the order itself is valid */
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[type="submit"]');
    if (!btn || !btn.form || gtBypass || !gt.on || !btn.form.__tlfPlanner || !gtVariant()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var wasBN = bnClicking;
    var form = btn.form, p = form.__tlfPlanner;
    gtEnsure(form).then(function (ok) {
      if (!ok) { bnUntil = 0; showError(p, 'Could not add the live guitarist. Please try again.'); return; }
      gtBypass = true;
      if (wasBN) { bnArm(); bnClicking = true; }
      try { btn.click(); } finally { gtBypass = false; bnClicking = false; }
    });
  }, true);

  /* ---------- discovery ---------- */
  function scan() {
    clampDescriptions();
    document.querySelectorAll('[data-tlf-planner]').forEach(init);
    planners = planners.filter(function (p) { return document.contains(p.root); });
    planners.forEach(function (p) {
      var f = formOf(p.root);
      var needs = (f && (f.__tlfPlanner !== p || (state.zone && !f.querySelector('[data-tlf-dp][name="' + P_PIN + '"]'))));
      if (needs) render(p);
    });
    addBuyNow();
    gtRender();
    gtLoadSpend();
  }
  window.__tlfDP = { scan: scan, state: state };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
  /* re-evaluate slot availability as time passes */
  setInterval(renderAll, 60000);
})();
